module.exports = __webpack_public_path__ + "img/eur.08cc0710.png";